<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <CRow class="ml-2">
                <span v-if="teacher.picturePath == ''" class="custom-header-profile">
                  <img
                    width="50px"
                    height="50px"
                    src="../../assets/img/icon/icondefault.svg"
                  />     
                </span>

                <span v-else class="custom-header-profile">
                  <img 
                    :src="teacher.picturePath" 
                    width="50px"
                    height="50px"
                    style="border-radius: 30px;"
                  />           
                </span>
                
                <div class="ml-2 mt-3">
                  <span class="custom-user-title" style="margin-bottom: 5px;"> {{ teacher.name }} </span>
                </div>              
              </CRow>

            <h4 style="color: #000; text-align: left" class="custom-user-grade">
              Select the your academic institution
            </h4>
            <br />

            <form class="ml-3 mr-3">
              <input
                type="text"
                class="custom-input-user"
                placeholder="Search Institution"
                v-model="SearchQuery"
              />
              <img
                src="../../assets/img/icon/iconContainer.svg"
              />
            </form>

            <div class="list-grade">
              <CRow>
                <CCol 
                  sm="12" 
                  v-for="item in FilteredInstitute" 
                  v-bind:key="item.id"
                  @click="GoToTeachingSchool()"
                >
                  <div class="">
                    <input
                      type="radio"
                      id="item.instituteName"
                      v-model="item.instituteName"
                      class="mr-2 ml-2"                      
                    />
                    {{ item.instituteName }}
                  </div>
                  <div style="clear: both"></div>
                  <hr />
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">Academic Institution</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
export default {
  data: function () {
    return {
      user: {},
      grade: [],
      FilterGrade: [],
      SelectedGrade: "",
      SearchQuery: "",
      teacher: {},
      institute: [],

      studentProfileAuthorize: "",

    };
  },

  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },

  computed: {
    FilteredInstitute() {
      return this.institute.filter(item => {
        return item.instituteName.toLowerCase().includes(this.SearchQuery.toLowerCase())
      })
    }
  },

  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetTeacherProfile(this.user.id);
            this.GetInstituteList();
          }
        });
    },

    GetTeacherProfile() {
      this.$API
        .get(this.$TeacherProfile + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teacher = response.data;
            this.photoURL = this.teacher;
              console.log("teacher", this.teacher);
          }
        });
    },

    GetInstituteList() {
      this.$API
        .get(this.$InstituteList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.institute = response.data;
          }
        });
    },

    GoToTeachingSchool() {
      this.$router.push("BTTeachingSchool");
    },

    GoBack() {
      this.$router.back();
    },
   
    
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input[type="text"] {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}
input[type="radio"] {
  opacity: 0;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  margin-top: 129px;
  height: 100vh;

  /* Off white */

  background: #f9f9f9;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}
</style>